import { render, staticRenderFns } from "./UserGameReport.vue?vue&type=template&id=9123d04e&scoped=true"
import script from "./UserGameReport.vue?vue&type=script&lang=js"
export * from "./UserGameReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9123d04e",
  null
  
)

export default component.exports